import styled from '@emotion/styled';

export const AccordionContent = styled.div`
  padding: 16px 24px;
  text-align: left;

  ul {
    list-style: inside !important;
  }
`;

export const CookieCategory = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const accordionLabelStyle = styled.div`
  width: 100%;
`;
